// English Form Mapping Configuration
export const FORM_MAPPING_CONFIG_ENG: Record<
  string,
  (branch?: any, user?: any) => Record<string, any>
> = {
  // Form 433-A
  f433a: (branch, user) => {
    const fullName = [user?.first_name, user?.last_name].filter(Boolean).join(' ')
    const phone = String(user?.phone || '').replace(/[()-]/g, '')

    return {
      'topmostSubform[0].Page1[0].c1[0].Lines1a-b[0].p1-t4[0]': fullName,
      'topmostSubform[0].Page1[0].c1[0].#subform[1].p1-t5[0]': branch?.businessAddress || '',
      'topmostSubform[0].Page1[0].c1[0].Line1c[0].p1-t6c[0]': phone.slice(0, 3) || '',
      'topmostSubform[0].Page1[0].c1[0].Line1c[0].p1-t7c[0]': phone ? phone.slice(-7) : '',
      'topmostSubform[0].Page1[0].c1[0].Line1d[0].p1-t8d[0]': phone.slice(0, 3) || '',
      'topmostSubform[0].Page1[0].c1[0].Line1d[0].p1-t9d[0]': phone ? phone.slice(-7) : '',
      'topmostSubform[0].Page1[0].c1[0].Lines1a-b[1].p1-t4[0]': branch?.country || '',
    }
  },
}

// Spanish Form Mapping Configuration
export const FORM_MAPPING_CONFIG_ESP: Record<
  string,
  (branch?: any, user?: any) => Record<string, any>
> = {
  // Form 433-A
  f433a: (branch, user) => {
    const fullName = [user?.first_name, user?.last_name].filter(Boolean).join(' ')
    const phone = String(user?.phone || '').replace(/[()-]/g, '')

    return {
      'topmostSubform[0].Page1[0].c1[0].Lines1a-b[0].p1-t4[0]': fullName,
      'topmostSubform[0].Page1[0].c1[0].#subform[1].p1-t5[0]': branch?.businessAddress || '',
      'topmostSubform[0].Page1[0].c1[0].Line1c[0].p1-t6c[0]': phone.slice(0, 3) || '',
      'topmostSubform[0].Page1[0].c1[0].Line1c[0].p1-t7c[0]': phone ? phone.slice(-7) : '',
      'topmostSubform[0].Page1[0].c1[0].Line1d[0].p1-t8d[0]': phone.slice(0, 3) || '',
      'topmostSubform[0].Page1[0].c1[0].Line1d[0].p1-t9d[0]': phone ? phone.slice(-7) : '',
      'topmostSubform[0].Page1[0].c1[0].Lines1a-b[1].p1-t4[0]': branch?.country || '',
    }
  },
}

/**
 * Generic Pre-Fill Logic for Forms
 */
export const preFillAnyForm = (
  formType: string,
  existingFields: Record<string, any> = {},
  branchData?: Record<string, any>,
  userData?: Record<string, any>,
  pnlData?: any
): Record<string, any> => {
  const getlang = localStorage.getItem('i18nextLng')
  const lang = getlang === 'en' || getlang === 'en-US' || getlang === 'en-us' ? 'en-US' : 'es'
  const getFormFallback = lang === 'en-US' ? FORM_MAPPING_CONFIG_ENG[formType] : FORM_MAPPING_CONFIG_ESP[formType]

  if (!getFormFallback) {
    console.warn(`No field mapping found for form type: ${formType}`)
    return existingFields
  }

  const formFallbacks = getFormFallback(branchData, userData)
  const result: Record<string, any> = { ...existingFields }

  Object.entries(formFallbacks).forEach(([fieldKey, fallbackValue]) => {
    const pdfValue = existingFields[fieldKey]

    const hasPdfValue =
      pdfValue !== undefined &&
      pdfValue !== null &&
      pdfValue !== '' &&
      pdfValue !== false

    if (hasPdfValue) {
      result[fieldKey] = pdfValue
    } else if (fallbackValue !== undefined && fallbackValue !== null && fallbackValue !== '') {
      result[fieldKey] = fallbackValue
    } else {
      result[fieldKey] = typeof fallbackValue === 'boolean' ? false : ''
    }
  })

  return result
}